import React from 'react';
import { Pagination } from '@material-ui/lab';

export default function Paginations(props) {

    const [page, setPage] = React.useState(1);

    const handlePagingChange = (event, value) => {
        props.handlePagingChange(value);
        setPage(value);
    };
  
    return (
      <div>
        <Pagination count={props.count} page={page} onChange={handlePagingChange} color="primary" />
      </div>
    );
}